<app-page-body>
  <!-- header -->
  <app-page-header
    [title]="title"
    [isForm]="true"
    [loading]="loading"
    (onBack)="onClose()"
    (onRefresh)="onReset()"
  >
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <!-- form -->
    <form [formGroup]="form" autocomplete="off">
      <div class="row">
        <section class="tw-w-full">
          <fieldset>
            <legend>{{ "common.specifications" | translate }}</legend>

            <div class="row tw-mb-2">
              <!-- name -->
              <div
                class="sm:tw-w-1/2 tw-pr-[20px] ltr:tw-pl-[20px] tw-pl-[15px]"
              >
                <form-field
                  [(value)]="model.name"
                  [control]="form?.get('name')"
                  label="common.name"
                  [maxLength]="100"
                >
                </form-field>
              </div>
            </div>

            <div class="row">
              <organization-selection-list
                type="childrenAndItselfList"
                searchLabel="messages.searchInOrganizations"
                [values]="model.organizationIds"
                (values)="model.organizationIds = $event"
              >
              </organization-selection-list>
            </div>
          </fieldset>
        </section>
      </div>

      <!-- form btns-->
      <app-form-btns
        [loading]="loading"
        [form]="form"
        [isEdit]="formPageConfig.isEditMode"
        (onClose)="onClose()"
        (onSubmit)="onSubmit()"
      >
      </app-form-btns>
    </form>
  </div>
</app-page-body>
